<template>
    <period-heatmap
        title="Scoring by Period"
        :caption="`${option === 0 ? 'Average points per game' : 'Total points'} in each period · shaded against each player's best period`"
        label-header="Player"
        :total-header="option === 0 ? 'PPG' : 'PTS'"
        :rows="rows"
        clickable
        @row-click="row => $router.push({ path: `/Player/${row.player.id}` })"
    >
        <template v-slot:label="{ row }">
            <img
                :src="`${assetsUrl}/${row.player.image}`"
                class="heatmap-player-img"
                @error="$event.target.src = defaultPlayerImg"
            >
            <span class="heatmap-player-jersey secondary-font custom-orange-text">{{ row.player.jersey }}</span>
            <span class="heatmap-player-name">{{ row.player.name }} {{ row.player.surname }}</span>
        </template>
    </period-heatmap>
</template>

<script>
    import PeriodHeatmap from '@/components/PeriodHeatmap.vue'
    import { bucketPeriodScore } from '@/utils/periodStats'

    export default {
        name: 'PlayerPeriodHeatmap',
        components: {
            PeriodHeatmap
        },
        props: {
            players: {
                type: Array,
                default: () => []
            },
            // 0 = averages, 1 = totals (same as the TeamStats chips)
            option: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com',
                defaultPlayerImg: require('@/assets/default_player.png')
            }
        },
        computed: {
            rows() {
                return (this.players || [])
                    .filter(player => player.active)
                    .map(player => this.buildRow(player))
                    .filter(row => row.total > 0)
                    .sort((a, b) => b.total - a.total)
            }
        },
        methods: {
            buildRow(player) {
                const games = Array.isArray(player.stats) ? player.stats : []
                const totals = bucketPeriodScore({})
                games.forEach(game => bucketPeriodScore(game.periodScore, totals))
                const divisor = this.option === 0 && games.length > 0 ? games.length : 1
                const values = {}
                Object.keys(totals).forEach(key => {
                    values[key] = totals[key] / divisor
                })
                const total = Object.values(values).reduce((sum, points) => sum + points, 0)
                return { id: player.id, player, values, total, decimals: this.option === 0 }
            }
        }
    }
</script>

<style scoped>
.heatmap-player-img {
    flex: 0 0 auto;
    width: 38px;
    height: 38px;
    object-fit: cover;
    object-position: top;
    border-radius: 50%;
    background: #f3f3f3;
    box-shadow: 0 0 0 2px #ffd9c4;
}

.heatmap-player-jersey {
    flex: 0 0 28px;
    font-size: 0.95rem;
    text-align: right;
}

.heatmap-player-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 1.05rem;
}
</style>
